export const tag1SelectableOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'R', 'S', 'T', 'V', 'W', 'Y'].map((c) => ({ value: c, text: c }))
export const tag2SelectableOptions = Array.from({ length: 20 }, (_, i) => ({ value: String(i + 1), text: String(i + 1) }))

export const tag1Options = [{ value: null, text: '選択なし' }, ...tag1SelectableOptions]
export const tag2Options = [{ value: null, text: '選択なし' }, ...tag2SelectableOptions]
